import * as React from 'react'

export default class Tree extends React.PureComponent {
	render() {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 124.986 200.673"
				className="Canvas-tree"
			>
				<g>
					<g>
						<rect
							x="53.046"
							y="161.046"
							width="17.859"
							height="39.627"
							transform="matrix(1,0,0,1,0,0)"
							fill="rgb(0,0,0)"
						/>
						<path
							d=" M 123.9675 151.782 L 99.8535 116.172 L 111.5655 116.172 C 116.2665 116.172 119.0535 110.916 116.4195 107.025 L 88.0185 65.085 L 98.6295 65.085 C 103.3305 65.085 106.1175 59.829 103.4835 55.938 L 67.3455 2.574 C 65.0205 -0.858 59.9625 -0.858 57.6375 2.574 L 21.5025 55.935 C 18.8655 59.826 21.6555 65.082 26.3565 65.082 L 36.9675 65.082 L 8.5665 107.022 C 5.9295 110.916 8.7195 116.169 13.4205 116.169 L 25.1325 116.169 L 1.0185 151.779 C -1.6185 155.67 1.1715 160.926 5.8725 160.926 L 119.1135 160.926 C 123.8145 160.929 126.6045 155.673 123.9675 151.782 Z "
							className="Canvas-tree-crown"
							fill={this.props.color || 'rgb(0,255,0)'}
						/>
					</g>
				</g>
			</svg>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Tree.js